import { Component, EventEmitter, Input, Output } from '@angular/core'
import { HelperService } from '../../../../../services/helper.service'
import { IDataCardBPI } from '../../../../../models/data-card.model'
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component'
import { NzModalService } from 'ng-zorro-antd/modal'

@Component({
    selector: 'app-data-binary-process-ini',
    templateUrl: './data-binary-process-ini.component.html',
    standalone: false
})
export class DataBinaryProcessIniComponent {
  @Input() data: IDataCardBPI
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  @Output() openSDLEvent: EventEmitter<string> = new EventEmitter()

  constructor(private nzModalService: NzModalService) {}

  public getSIFParams(mo: string): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          initiator: mo,
        }),
      ),
    }
  }

  public hasUrlBadges(): boolean {
    return !!(
      this.data &&
      (this.data.Dev_Active ||
        this.data.Dev_InActive_Count ||
        this.data.Flt_Active ||
        this.data.Flt_InActive_Count ||
        this.data.Dmd_Active ||
        this.data.Dmd_InActive_Count ||
        this.data.Ovr_Active ||
        this.data.Ovr_InActive_Count)
    )
  }

  public onOpenNotificationModal(tag: string, notifications?: number): void {
    if (!notifications) {
      return
    }

    this.nzModalService.create<NotificationsModalComponent, { mainObject: string }, any>({
      nzContent: NotificationsModalComponent,
      nzStyle: { top: '30px' },
      nzData: { mainObject: tag },
      nzNoAnimation: true,
    })
  }
  public getSDLs(): string[] {
    if (this.data.SDL) {
      return this.data.SDL.split(',').map((sdl: string) => sdl.trim())
    }
    return []
  }

  public onOpenSDL(sdl: string): void {
    this.openSDLEvent.next(sdl)
  }
}
